import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Review {
  name: string;
  age: string;
  city: string;
  text: string;
  stars: number;
}
export function TestimonialsSection() {
  const initialTestimonials: Review[] = [{
    name: 'Martín G.',
    age: '32 años',
    city: 'Buenos Aires',
    text: 'Escucho audiolibros mientras manejo al trabajo. En 3 meses siento que aprendí más que en años. Mi mentalidad cambió completamente.',
    stars: 5
  }, {
    name: 'Lucía R.',
    age: '28 años',
    city: 'Córdoba',
    text: 'Como emprendedora, necesitaba ideas nuevas constantemente. Esta biblioteca me da eso todos los días. Los bonos de dinero me ayudaron muchísimo.',
    stars: 5
  }, {
    name: 'Diego M.',
    age: '41 años',
    city: 'Rosario',
    text: 'Soy padre de 3 hijos y no tenía tiempo para leer. Ahora escucho mientras cocino, mientras llevo a los chicos... Increíble la cantidad de contenido.',
    stars: 5
  }, {
    name: 'Valentina S.',
    age: '35 años',
    city: 'Mendoza',
    text: 'El curso de lectura rápida solo ya vale más que todo lo que pagué. La biblioteca es un tesoro. La recomiendo a todos mis colegas.',
    stars: 5
  }, {
    name: 'Santiago P.',
    age: '26 años',
    city: 'La Plata',
    text: 'Empecé escuchando 20 minutos al día y ahora no puedo parar. Mi productividad y mi forma de pensar mejoraron muchísimo.',
    stars: 5
  }];
  const [reviews, setReviews] = useState<Review[]>(initialTestimonials);
  const [newName, setNewName] = useState('');
  const [newText, setNewText] = useState('');
  const [newStars, setNewStars] = useState(5);
  const [hoveredStar, setHoveredStar] = useState(0);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newName.trim() || !newText.trim() || newStars === 0) return;
    const newReview: Review = {
      name: newName,
      age: 'Cliente',
      city: 'Verificado',
      text: newText,
      stars: newStars
    };
    setReviews([newReview, ...reviews]);
    setNewName('');
    setNewText('');
    setNewStars(5);
  };
  return <section className="py-10 px-4 bg-[#1F2937] border-y border-gray-800" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-237">
            Lo que dicen quienes ya están aprendiendo
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10" data-id="element-238">
            {reviews.map((t, idx) => <div key={idx} className="bg-gray-800 p-6 rounded-2xl shadow-lg border border-gray-700 flex flex-col" data-id="element-239">
                <div className="flex text-[#8FF650] mb-3" data-id="element-240">
                  {[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < t.stars ? 'fill-current' : 'text-gray-600'}`} data-id="element-241" />)}
                </div>

                <p className="text-base text-gray-200 font-medium italic mb-4 flex-grow" data-id="element-242">
                  "{t.text}"
                </p>

                <div className="flex items-center gap-3 mt-auto" data-id="element-243">
                  <div className="w-10 h-10 bg-[#8FF650] rounded-full flex items-center justify-center text-black font-black text-lg" data-id="element-244">
                    {t.name.charAt(0).toUpperCase()}
                  </div>
                  <div data-id="element-245">
                    <p className="font-black text-white text-sm" data-id="element-246">{t.name}</p>
                    <p className="text-xs text-gray-400 font-bold" data-id="element-247">
                      {t.age} • {t.city}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Review Form */}
          <div className="max-w-2xl mx-auto bg-gray-900 p-6 rounded-2xl border border-gray-700 shadow-xl" data-id="element-248">
            <h3 className="text-2xl font-black text-white mb-4 text-center" data-id="element-249">
              Dejá tu reseña
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-250">
              <div data-id="element-251">
                <label className="block text-sm font-bold text-gray-300 mb-1" data-id="element-252">
                  Tu Nombre
                </label>
                <input type="text" required value={newName} onChange={e => setNewName(e.target.value)} className="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-[#8FF650]" placeholder="Ej: Juan P." data-id="element-253" />
              </div>

              <div data-id="element-254">
                <label className="block text-sm font-bold text-gray-300 mb-1" data-id="element-255">
                  Calificación
                </label>
                <div className="flex gap-1" data-id="element-256">
                  {[1, 2, 3, 4, 5].map(star => <button type="button" key={star} onClick={() => setNewStars(star)} onMouseEnter={() => setHoveredStar(star)} onMouseLeave={() => setHoveredStar(0)} className="focus:outline-none" data-id="element-257">
                      <Star className={`w-8 h-8 ${star <= (hoveredStar || newStars) ? 'text-[#8FF650] fill-current' : 'text-gray-600'} transition-colors`} data-id="element-258" />
                    </button>)}
                </div>
              </div>

              <div data-id="element-259">
                <label className="block text-sm font-bold text-gray-300 mb-1" data-id="element-260">
                  Tu Experiencia
                </label>
                <textarea required value={newText} onChange={e => setNewText(e.target.value)} rows={3} className="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-[#8FF650] resize-none" placeholder="Contanos qué te pareció la biblioteca..." data-id="element-261" />
              </div>

              <button type="submit" className="w-full bg-[#8FF650] hover:bg-[#7DE040] text-black font-black py-3 rounded-lg transition-colors uppercase tracking-wide" data-id="element-262">
                Publicar Reseña
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>;
}